import React from 'react';
import { Building, MapPin, Flag, ArrowRight, Landmark } from 'lucide-react';

interface ScanSimilarCompaniesDetailsProps {
  t: (key: string) => string;
  organizationFound: boolean;
  totalSimilar: number;
  sameCity: number;
  sameCountry: number;
  onViewMore: () => void;
}

const ScanSimilarCompaniesDetails: React.FC<ScanSimilarCompaniesDetailsProps> = ({
  t,
  organizationFound,
  totalSimilar,
  sameCity,
  sameCountry,
  onViewMore,
}) => {
  const viewMoreButtonClasses = 
    'px-6 py-2 text-lg bg-gradient-to-r from-yellow-500 to-yellow-700 hover:from-yellow-600 hover:to-yellow-800 ' +
    'rounded-lg flex items-center gap-2 transition-all text-white shadow-md shadow-yellow-900';

  if (!organizationFound) {
    return (
      <div className="mt-8 bg-gray-900 bg-opacity-60 backdrop-blur-md p-6 rounded-xl shadow-lg shadow-black/30 border border-gray-700 text-center flex flex-col items-center">
        <Landmark className="w-16 h-16 text-gray-400 mb-4" />
        <p className="text-gray-300 text-lg font-medium">
          {t('scan.noOrgFound') || 'No organization found for this domain'}
        </p>
      </div>
    );
  }

  return (
    <div className="mt-8 bg-gray-900 bg-opacity-60 backdrop-blur-md p-6 rounded-xl shadow-lg shadow-black/30 border border-gray-700">
      <h3 className="text-xl font-semibold text-gray-200 mb-6 text-center">
        {t('scan.similarCompaniesDetails') || 'Similar Companies'}
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Total Similar Companies */}
        <div className="bg-gray-800 p-6 rounded-xl flex flex-col items-center transition duration-200 hover:bg-gray-700 shadow-md">
          <Building className="w-14 h-14 text-green-400 drop-shadow-md" />
          <p className="text-3xl font-bold text-white mt-2">{totalSimilar}</p>
          <p className="text-gray-300 text-sm mt-1">{t('scan.totalSimilar') || 'Total'}</p>
        </div>

        {/* Same Country */}
        <div className="bg-gray-800 p-6 rounded-xl flex flex-col items-center transition duration-200 hover:bg-gray-700 shadow-md">
          <Flag className="w-14 h-14 text-yellow-400 drop-shadow-md" />
          <p className="text-3xl font-bold text-white mt-2">{sameCountry}</p>
          <p className="text-gray-300 text-sm mt-1">{t('scan.sameCountry') || 'Same Country'}</p>
        </div>

        {/* Same City */}
        <div className="bg-gray-800 p-6 rounded-xl flex flex-col items-center transition duration-200 hover:bg-gray-700 shadow-md">
          <MapPin className="w-14 h-14 text-blue-400 drop-shadow-md" />
          <p className="text-3xl font-bold text-white mt-2">{sameCity}</p>
          <p className="text-gray-300 text-sm mt-1">{t('scan.sameCity') || 'Same City'}</p>
        </div>

      </div>

      {/* Botón "Ver más" */}
      <div className="mt-6 flex justify-center">
        <button className={viewMoreButtonClasses} onClick={onViewMore}>
          {t('scan.viewMore') || 'View more'}
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ScanSimilarCompaniesDetails;
